"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePageViews = exports.trackAddShippingInfo = exports.trackProductClick = exports.trackRemoveFromCart = exports.trackPurchase = exports.trackProductView = exports.trackBeginCheckout = exports.trackViewCart = exports.trackAddToCart = void 0;
var react_ga4_1 = __importDefault(require("react-ga4"));
function usePageViews(path) {
    try {
        console.log("page_view", path);
        react_ga4_1.default.send({ hitType: "pageview", page: path });
        console.log("page_view sent successfully");
    }
    catch (error) {
        console.error("Error sending event to Google Analytics:", error);
    }
}
exports.usePageViews = usePageViews;
function trackAddToCart(data) {
    var _a;
    try {
        react_ga4_1.default.event("add_to_cart", {
            value: data.price,
            currency: "ZAR",
            label: data.title,
            items: (_a = data === null || data === void 0 ? void 0 : data.products) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({
                item_name: item.title,
                item_sku: item.sku,
                price: item.price,
                quantity: item.quantity,
                item_id: item._id,
            }); }),
        });
        console.log("add_to_cart sent successfully");
    }
    catch (error) {
        console.error("Error sending event to Google Analytics:", error);
    }
}
exports.trackAddToCart = trackAddToCart;
function trackRemoveFromCart(data) {
    var _a;
    try {
        react_ga4_1.default.event("remove_from_cart", {
            value: data.price,
            currency: "ZAR",
            label: data.title,
            items: (_a = data === null || data === void 0 ? void 0 : data.products) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({
                item_name: item.title,
                item_sku: item.sku,
                price: item.price,
                quantity: item.quantity,
                item_id: item._id,
            }); }),
        });
        console.log("add_to_cart sent successfully");
    }
    catch (error) {
        console.error("Error sending event to Google Analytics:", error);
    }
}
exports.trackRemoveFromCart = trackRemoveFromCart;
function trackViewCart(data) {
    var _a;
    try {
        react_ga4_1.default.event("view_cart", {
            value: data.price,
            currency: "ZAR",
            items: (_a = data === null || data === void 0 ? void 0 : data.products) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({
                item_name: item.title,
                item_id: item._id,
                price: item.price,
                quantity: item.quantity,
                item_sku: item.sku,
                currency: "ZAR",
            }); }),
        });
        console.log("view_cart sent successfully");
    }
    catch (error) {
        console.error("Error sending event to Google Analytics:", error);
    }
}
exports.trackViewCart = trackViewCart;
function trackBeginCheckout(data) {
    var _a;
    try {
        react_ga4_1.default.event("begin_checkout", {
            value: data.price,
            currency: "ZAR",
            label: data.title,
            items: (_a = data === null || data === void 0 ? void 0 : data.products) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({
                item_name: item.title,
                item_sku: item.sku,
                price: item.price,
                quantity: item.quantity,
                item_id: item._id,
            }); }),
        });
        console.log("begin_checkout sent successfully");
    }
    catch (error) {
        console.error("Error sending event to Google Analytics:", error);
    }
}
exports.trackBeginCheckout = trackBeginCheckout;
function trackProductView(data) {
    var _a;
    try {
        react_ga4_1.default.event("view_item", {
            value: data.price,
            currency: "ZAR",
            label: data.title,
            items: (_a = data === null || data === void 0 ? void 0 : data.products) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({
                item_name: item.title,
                item_sku: item.sku,
                price: item.price,
                quantity: item.quantity,
                item_id: item._id,
            }); }),
        });
        console.log("view_item sent successfully");
    }
    catch (error) {
        console.error("Error sending event to Google Analytics:", error);
    }
}
exports.trackProductView = trackProductView;
function trackProductClick(data) {
    var _a;
    try {
        react_ga4_1.default.event("item_click", {
            value: data.price,
            currency: "ZAR",
            label: data.title,
            items: (_a = data === null || data === void 0 ? void 0 : data.products) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({
                item_name: item.title,
                item_sku: item.sku,
                price: item.price,
                quantity: item.quantity,
                item_id: item._id,
            }); }),
        });
        console.log("view_item sent successfully");
    }
    catch (error) {
        console.error("Error sending event to Google Analytics:", error);
    }
}
exports.trackProductClick = trackProductClick;
// function trackRemoveFromCart(data: AnalyticsEventData) {
//   gtag("send", "event", {
//     eventCategory: "Ecommerce",
//     eventAction: "Remove from Cart",
//     eventLabel: data.title,
//     eventValue: data.price ?? 0 * (data.quantity || 1),
//     dimension1: data._id,
//     dimension2: data.title,
//     dimension3: data.category,
//     dimension4: data.quantity,
//   });
// }
function trackAddShippingInfo(data) {
    var _a;
    try {
        react_ga4_1.default.event("add_shipping_info", {
            value: data.price,
            currency: "ZAR",
            label: data.title,
            items: (_a = data === null || data === void 0 ? void 0 : data.products) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({
                item_name: item.title,
                item_sku: item.sku,
                price: item.price,
                quantity: item.quantity,
                item_id: item._id,
            }); }),
        });
        console.log("add_shipping_info sent successfully");
    }
    catch (error) {
        console.error("Error sending event to Google Analytics:", error);
    }
}
exports.trackAddShippingInfo = trackAddShippingInfo;
// function trackAddPaymentInfo(data: AnalyticsEventData) {
//   gtag("send", "event", {
//     eventCategory: "Ecommerce",
//     eventAction: "Add Payment Info",
//     eventLabel: data.paymentMethod,
//   });
// }
function trackPurchase(data) {
    var _a;
    try {
        react_ga4_1.default.event("purchase", {
            value: data.price,
            currency: "ZAR",
            transaction_id: data.transaction_id,
            items: (_a = data === null || data === void 0 ? void 0 : data.products) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({
                item_name: item.title,
                item_id: item._id,
                price: item.price,
                quantity: item.quantity,
                item_sku: item.sku,
                currency: "ZAR",
            }); }),
        });
        console.log("purchase sent successfully");
    }
    catch (error) {
        console.error("Error sending event to Google Analytics:", error);
    }
}
exports.trackPurchase = trackPurchase;
